import { useEffect, useMemo, useState } from 'react';
import { useSiteConfig } from 'mf_core/config';
import { injectScriptInBody } from './utils';
import { useIsAuthenticated, useDecodedToken } from 'mf_core/auth';
import { useLocation } from 'react-router';
import { getLsObject } from '@im/ui-lib/utils/local-storage.utils';
import { useLocalizationContext } from '@im/react-localization';

interface AccountResultTO {
  accountID?: string;
  companycode?: string;
  countryID?: string;
  currencyID?: string;
  ownerID?: string;
  priceList?: string;
}

export function useChatBotHelpMenu() {
  const { environment, siteCode } = useSiteConfig();
  const { pathname } = useLocation();
  const isAuthenticated = useIsAuthenticated();
  const decodedToken = useDecodedToken();
  const defaultVisibility = siteCode === 'mx';
  const [showChatbot, setShowChatbot] = useState(defaultVisibility);

  const firstName: string = decodedToken?.imoProfile?.firstName || '';
  const lastName: string = decodedToken?.imoProfile?.lastName || '';
  const email: string = decodedToken?.email || '';
  const userId: string = decodedToken?.userId || '';
  const { locale } = useLocalizationContext();
  const language = locale;
  const accountId = useMemo(() => {
    const accountResponse = getLsObject('getAccount', { data: {} });
    const accountData: AccountResultTO =
      accountResponse?.data || accountResponse;
    return accountData?.accountID || '';
  }, []);

  const name = `${firstName} ${lastName}`;
  const resellerId = decodedToken?.resellerId;
  const resellerInfoHTML = `<span id="reseller-id" style="display:none">${resellerId}</span><span id="reseller-name" style="display:none">${name}</span><span id="account-id" style="display:none">${accountId}</span><span id="email-id" style="display:none">${email}</span><span id="environment-name" style="display:none">${environment}</span><span id="language-name" style="display:none">${language}</span><span id="user-id" style="display:none">${userId}</span>`;
  const resellerInfoContainer = document.createElement('div');
  resellerInfoContainer.id = 'reseller-info';
  resellerInfoContainer.innerHTML = resellerInfoHTML;
  if (resellerId && !document.getElementById('reseller-info') && name)
    document.body.appendChild(resellerInfoContainer);

  const win = window as any;
  win.chatBotOnHelpMenu = {
    toggleChatBot: () => {
      setShowChatbot(!showChatbot);
    },
  };
  useEffect(() => {
    if (pathname.includes('/general/contact-us')) {
      setShowChatbot(false);
    } else if (siteCode === 'mx' && !pathname.includes('/general/contact-us')) {
      setShowChatbot(true);
    }
  }, [siteCode, pathname]);

  useEffect(() => {
    if (isAuthenticated) {
      if (showChatbot) {
        loadScriptInBody(siteCode);
      }
      const chatBotContainerCO = document.getElementById(
        'chat-widget-container'
      );
      const chatBotContainerMx = document.getElementById('chatbot-chat');
      if (chatBotContainerCO) {
        chatBotContainerCO.style.display =
          !showChatbot || pathname.includes('/my/checkout') ? 'none' : 'block';
      }
      if (chatBotContainerMx) {
        chatBotContainerMx.style.display =
          !showChatbot || pathname.includes('/my/checkout') ? 'none' : 'block';
      }
    }
  }, [siteCode, showChatbot, isAuthenticated, pathname]);
}

const loadScriptInBody = function (siteCode: string) {
  switch (siteCode) {
    case 'co': {
      if (!document.getElementById('co_chatbot_script')) {
        const script_text_chatbot_co = `window.__lc=window.__lc||{};window.__lc.license=11382707;(function(){var a=document.createElement("script");a.type="text/javascript";a.async=!0;a.src=("https:"==document.location.protocol?"https://":"http://")+"cdn.livechatinc.com/tracking.js";var b=document.getElementsByTagName("script")[0];b.parentNode.insertBefore(a,b)})();`;
        injectScriptInBody(script_text_chatbot_co, 'co_chatbot_script');
      }
      break;
    }
    case 'mx': {
      if (!document.getElementById('mx_chatbot_script')) {
        const script_text_chatbot_mx = `window.__lc=window.__lc||{};var reseller_bot="",uname_bot="",accountId_bot="",email_bot="",environment_bot="",language_bot="",userId_bot="";if(document.getElementById("reseller-id")){reseller_bot=document.getElementById("reseller-id").innerHTML}if(document.getElementById("reseller-name")){uname_bot=document.getElementById("reseller-name").innerHTML}if(document.getElementById("account-id")){accountId_bot=document.getElementById("account-id").innerHTML}if(document.getElementById("email-id")){email_bot=document.getElementById("email-id").innerHTML}if(document.getElementById("environment-name")){environment_bot=document.getElementById("environment-name").innerHTML}if(document.getElementById("language-name")){language_bot=document.getElementById("language-name").innerHTML}if(document.getElementById("user-id")){userId_bot=document.getElementById("user-id").innerHTML}window.__lc.params=[{name:"name",value:uname_bot},{name:"resellerid",value:reseller_bot},{name:"accountId",value:accountId_bot},{name:"email",value:email_bot},{name:"environment",value:environment_bot},{name:"language",value:language_bot},{name:"userId",value:userId_bot}];window.__lc.license=8829336;window.__lc.group=19;console.log(window.__lc.group);(function(){var a=document.createElement("script");a.type="text/javascript";a.async=!0;a.src=("https:"==document.location.protocol?"https://":"http://")+"cdn.livechatinc.com/tracking.js";var b=document.getElementsByTagName("script")[0];b.parentNode.insertBefore(a,b)})();var LC_API=LC_API||{};LC_API.on_after_load=function(){LC_API.minimize_chat_window()};`;
        injectScriptInBody(script_text_chatbot_mx, 'mx_chatbot_script');
      }
      break;
    }
  }
};
